import { render, staticRenderFns } from "./Parcela.vue?vue&type=template&id=0a7814eb&scoped=true"
import script from "./Parcela.vue?vue&type=script&lang=js"
export * from "./Parcela.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=0a7814eb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7814eb",
  null
  
)

export default component.exports